<template>
  <vx-card no-shadow v-if="showWindow">
    <vs-popup classContent="popup-example" title="Update bank" :active.sync="popupBankDetails">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Account number" v-model="params.account_number" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="New Account number" v-model="params.new_account_number"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Bank name" v-model="params.bank_name"/>
        </div>
      </div>       
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Bank address" v-model="params.bank_address" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="IBAN" v-model="params.IBAN" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Swift" v-model="params.SWIFT" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select Company"
              autocomplete
              class="selectExample inputx w-full"
              label="Company"
              v-model="params.company"
              >
              <vs-select-item :key="index" :value="item.company_name" :text="item.company_name" v-for="(item,index) in companies" />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('bank-details')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Update bank" :active.sync="popupUpdateBank">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Unique" v-model="params.bank_unique" disabled/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Status</label>
          <select v-model="params.status"  class="inputx w-full" label="Status">
            <option>declined</option>
            <option>approved</option>
          </select>
        </div>
      </div>
       <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Reason</label>
          <select v-model="params.reason" class="form-control inputx w-full">
              <option></option>
              <option>bad pic</option>
              <option>brand</option>
              <option>outdated</option>
              <option>mismatching details</option>
              <option>client request</option>
              <option>wrong doc</option>
              <option>compliance</option>
              <option>suspected fraud</option>
          </select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Comment" v-model="params.comment" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <label>Email</label>
          <select v-model="params.checkbox"  class="inputx w-full" label="Email">
            <option>yes</option>
            <option>no</option>
          </select>
        </div>
      </div> 
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('update-bank')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th>last_updated</vs-th>
                <vs-th>bank_name</vs-th>
                <vs-th>company</vs-th>
                <vs-th>extra</vs-th>
                <vs-th>IBAN</vs-th>
                <vs-th>SWIFT</vs-th>
                <vs-th>account_number</vs-th>
                <vs-th>bank_address</vs-th>
                <vs-th>account_ver_status</vs-th>
                <vs-th>action</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td :data="data[indextr].last_updated">
                        {{data[indextr].last_updated}}
                    </vs-td>
                    <vs-td :data="data[indextr].bank_name">
                        {{data[indextr].bank_name}}
                    </vs-td>
                    <vs-td :data="data[indextr].company">
                        {{data[indextr].company}}
                    </vs-td>
                    <vs-td :data="data[indextr].extra">
                        {{data[indextr].extra}}
                    </vs-td>
                    <vs-td :data="data[indextr].IBAN">
                        {{data[indextr].IBAN}}
                    </vs-td>
                    <vs-td :data="data[indextr].SWIFT">
                        {{data[indextr].SWIFT}}
                    </vs-td>
                    <vs-td :data="data[indextr].account_number">
                        {{data[indextr].account_number}}
                    </vs-td>
                    <vs-td :data="data[indextr].bank_address">
                        {{data[indextr].bank_address}}
                    </vs-td>
                    <vs-td :data="data[indextr].account_ver_status">
                        {{data[indextr].account_ver_status}}
                    </vs-td>
                    <vs-td :data="data[indextr].action">
                        <vs-button @click="showBankDetails(data[indextr])" color="success" type="border">Change</vs-button>              
                    </vs-td>
                    <vs-td :data="data[indextr].action">
                        <vs-button @click="showUpdateBank(data[indextr])" color="primary" type="filled">View</vs-button>              
                    </vs-td>
                    <template  slot="expand">
                      <div class="vx-row w-full">
                        <div class="vx-col w-1/3">
                          <vs-input class="inputx w-full" label="Name" :value="details.first_name+' '+details.last_name"/>
                        </div>
                        <div class="vx-col w-1/3">
                          <vs-input class="inputx w-full" label="Address" :value="details.address+', '+details.city+' '+details.state+' '+details.Country+' '+details.postal"/>
                        </div>
                        <div class="vx-col w-1/3" v-if="data[indextr].doc!==undefined">
                          <br />
                          <a href='javascript:void(0)' @click="showDoc(data[indextr].doc)">Show doc</a>
                        </div>
                      </div>
                  </template>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import saleStatus from '../../../resources/sale_status.json';
export default {
  data() {
    return {
      details:{},
      popupSend: false,
      popupBankDetails: false,
      popupActive: false,
      params: {},
      originalParams:{},
      saleStatus:saleStatus,
      tableData:[],
      popupUpdateBank:false,
      companies: []
    }
  },
  components:{
    'v-select': vSelect,
  },
  computed: {
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    showDoc: function(link){
      window.open(link, '_blank');
    },
    showUpdateBank(data){
      this.params = {};
      this.popupUpdateBank = true;
      this.params.bank_unique = data.account_number;
    },
    showBankDetails(data){
      this.params = {};
      for(let i in data){
        if(i==='company' && data[i]==='none')
          continue;
        this.$set(this.params,i,data[i]);
        this.$set(this.originalParams,i,data[i]);        
      }
      this.popupBankDetails = true;
    },
    sendData: function(type){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('email', this.$route.params.email);
      if(type==='update-bank'){                
        params.append('comment', this.params.comment!==undefined ? this.params.comment : '');
        params.append('reason', this.params.reason!==undefined ? this.params.reason : '');
        params.append('status', this.params.status!==undefined ? this.params.status : '');
        params.append('bank-unique', this.params.bank_unique!==undefined ? this.params.bank_unique : '');
        params.append('checkbox', this.params.checkbox!==undefined ? this.params.checkbox : '');
        params.append('method', 'bank_acc');
      } else if(type==='bank-details'){
        params.append('method', 'bank_details_update');
        for(let i in this.params){
          if(i!=='account_number' && this.originalParams[i]!==undefined && this.params[i]===this.originalParams[i]){
            params.append(i, '');
          } else{
            params.append(i, this.params[i]);
          }
        }
      }
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((data) => {
        that.setData(true);
        that.$vs.loading.close();
        if(data.data[0].out1==='done!'/*|| that.successStatuses.indexOf(data.data[0].out1)!==-1*/){
          that.openAlert('success','Success',data.data[0].out1);
          that.reset();
        } else{
          that.openAlert('danger','Failed',data.data[0].out1);
        }
      })
      .catch((data) => { that.$vs.loading.close(); console.log('data',data); that.openAlert('danger','Failed',data.data[0].out1); })
    },
    reset: function(){
      this.popupActive= false;
      this.params= {};
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-banks');
      params.append('email', this.$route.params.email);
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data.data){
          let data = response.data.data[i];
          that.details = response.data.details;
          that.tableData.push(data);
        }
      })
      .catch((error) => { console.log('error',error) })    
      this.getCompanies();  
    },
    getCompanies: function(){
      const params = new URLSearchParams();
      params.append('type', 'get-companies');
      params.append('email', this.$route.params.email);
      let that = this;      
      axios.post("/api/client",params)
      .then((response) => {
        that.companies.splice(0);
        for(let i in response.data){
          let company = JSON.parse(response.data[i].object);          
          that.companies.push({company_name:company.company_name})
        }
      })
    }
  }
}
</script>
